'use client';

import * as React from 'react';

import { ResourceBadge } from '@/components/ui/resource-badge';
import { useOrgNavigate } from '@/hooks/use-app-navigate';

interface OrderResourceBadgeProps {
  orderId: string;
  orderNumber?: string | null;
  variant?: 'default' | 'secondary' | 'destructive' | 'outline';
  className?: string;
}

/**
 * OrderResourceBadge component for displaying order information
 * Inherits from generic ResourceBadge
 */
export function OrderResourceBadge({
  orderId,
  orderNumber,
  variant = 'secondary',
  className,
}: OrderResourceBadgeProps) {
  const { orgRoutes } = useOrgNavigate();
  // Use order number if available, otherwise use truncated order ID
  const displayValue = React.useMemo(() => {
    return orderNumber || `${orderId.substring(0, 8)}...`;
  }, [orderNumber, orderId]);


  return (
    <ResourceBadge
      name="order"
      value={displayValue}
      appLink={orgRoutes.ORDER_DETAILS(orderId)}
      variant={variant}
      className={className}
    />
  );
}
